module.exports = "<div class=\"container\">\n  <p *ngIf=\"order?.payment_type == 'card'\">\n    {{ 'PAID_BY_CARD' | translate }} {{ paidByCard }} {{ 'HRN' | translate }}.\n  </p>\n  <p *ngIf=\"order?.payment_type == 'phone'\">\n      {{ 'PAID_BY_KS' | translate }} {{ paidByCard }} {{ 'HRN' | translate }}.\n    </p>\n  <p *ngIf=\"order?.payment_type == 'card' && paidByCash > 0\">\n    {{ 'PAID_BY_CASH' | translate }} {{ paidByCash }} {{ 'HRN' | translate }}.\n  </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/card-pay/card-pay.component.html
// module id = ./src/app/dashboard/card-pay/card-pay.component.html
// module chunks = main